import { COUNTRY_CODES } from "../../../constants/countries";

export const INVOICE_LINES_CONFIG = {
    [COUNTRY_CODES.ECUADOR]: {
        requireAuthorizationForDiscount: () => true //siempre requiere autorizacion del admin para aplicar descuento en linea
    },
    [COUNTRY_CODES.HONDURAS]: {
        requireAuthorizationForDiscount: (discount) => { return discount >= 5; }
    },
};

export const getInvoiceLinesConfig = (country) => { return INVOICE_LINES_CONFIG[country] || INVOICE_LINES_CONFIG[COUNTRY_CODES.ECUADOR]; };